import { useTranslation } from 'react-i18next';
import { Box, Image } from '@chakra-ui/react';

import { TextBold, TextRegular } from 'UiKit/typography';
import logo from 'Asset/image/logo.svg';

import { useLoginState } from 'View/login/state';

import styles from './styles.module.css';

const Head = () => {
  const { state } = useLoginState();
  const { t } = useTranslation('login');
  return (
    <Box className={`${styles['head__container']} ${state?.errorMessage && styles['head__container--error']}`}>
      <Image src={logo} className={styles['logo__image']} />
      <TextBold className={styles['welcoming__text']}>{t('loginPage.welcome')}</TextBold>
      <TextRegular className={styles['description__text']}>{t('loginPage.descriptionWelcome')}</TextRegular>
    </Box>
  );
};

export default Head;
